<script>
import Layout from "../../layouts/main";
import config from "../../../config/config";
import { mapActions } from "vuex";
import { error_message, success_message } from "../../../state/helpers";
import { required } from "vuelidate/lib/validators";

/**
 * Starter component
 */
export default {
  components: { Layout },
  data() {
    return {
      config: config,
      typeform: {
        ios_version: "",
        android_version: "",
        status: 1,
      },
    };
  },
  validations: {
    typeform: {
      ios_version: {
        required,
      },
      android_version: {
        required,
      },
    },
  },
  mounted() {
    this.getVersion();
  },
  methods: {
    ...mapActions("version", ["getVersionById", "editVersion"]),
    getVersion() {
      this.getVersionById({ id: this.$route.params.id }).then((response) => {
        const { ios_version, android_version, status, id } = response.data.result;
        this.typeform = { ios_version, android_version, status, id };
      });
    },
    editPage() {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        this.editVersion(this.typeform).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.msg);
            this.$router.push({ name: "version-list" });
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon d-flex">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">Edit Version</h4>
              <p>
                <router-link :to="{ name: 'version-list' }">Versions</router-link> > Edit
                Version
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form @submit.prevent="editPage">
          <div class="card">
            <div class="card-body">
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">IOS Version</label>
                    <input
                      id="ios_version"
                      v-model="$v.typeform.ios_version.$model"
                      type="text"
                      class="form-control"
                      placeholder="IOS Version"
                      name="ios_version"
                      :class="{ 'is-invalid': $v.typeform.ios_version.$error }"
                    />
                    <div v-if="$v.typeform.ios_version.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.ios_version.required"
                        >Please Enter IOS Version</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">Andriod Version</label>
                    <input
                      id="android_version"
                      v-model="$v.typeform.android_version.$model"
                      type="text"
                      class="form-control"
                      placeholder="Andriod Version"
                      name="android_version"
                      :class="{ 'is-invalid': $v.typeform.android_version.$error }"
                    />
                    <div
                      v-if="$v.typeform.android_version.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.android_version.required"
                        >Please Enter Andriod Version</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 vendor-status">
                  <label>Status</label>
                  <b-form-checkbox
                    switch
                    size="lg"
                    v-model="typeform.status"
                    class="ml-1"
                    value="1"
                    unchecked-value="0"
                  ></b-form-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3">Update Version</button>
                  <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
